import React from 'react'
import GenerateLink from './generatepaymentlinkPopup'
import GenerateLinkAbhicash from './generatepaymentlinkPopupAbhicash'
import GeneratepaymentlinkPopupCashCreditjar from './generatepaymentlinkPopupCashCreditjar'
import { ABHICASH_ONLY, CASHBRIDGE_LIKE, CHECK_COMPANY_TENANT, CREDITJAR_LIKE } from '../../../../layouts/MainTenantconfig'
export default function Main({ openGenerateLink, emiDetail, userDetail, admin, tenant }) {
    return (
        <>
            {
                CHECK_COMPANY_TENANT(ABHICASH_ONLY) ?
                    <GenerateLinkAbhicash
                        openGenerateLink={openGenerateLink}
                        emiDetail={emiDetail}
                        userDetail={userDetail}
                        admin={admin}
                        tenant={tenant}
                    />
                    :
                    CHECK_COMPANY_TENANT(CASHBRIDGE_LIKE) || CHECK_COMPANY_TENANT(CREDITJAR_LIKE) ?
                        <GeneratepaymentlinkPopupCashCreditjar
                            openGenerateLink={openGenerateLink}
                            emiDetail={emiDetail}
                            userDetail={userDetail}
                            admin={admin}
                            tenant={tenant}
                        />
                        :
                        <GenerateLink
                            openGenerateLink={openGenerateLink}
                            emiDetail={emiDetail}
                            userDetail={userDetail}
                            admin={admin}
                            tenant={tenant}
                        />
            }
        </>
    )
}
